import { Injectable } from '@angular/core';
import { CanUpdateErrorStateCtor } from '@angular/material/core';
import { UserInfo, userInfo } from 'os';


interface User{
  email: string,
  documento: string,
  nombreUsuario: string
}

@Injectable()

export class TokenService {
  

  storageKey = 'tp:token';
  storageUser ='user';

  constructor() {
    
  }


  setUser(user:User){
    localStorage.setItem(this.storageUser, JSON.stringify(user));
  }

  setToken(token: string) {
   
    localStorage.setItem(this.storageKey, token);
  }

  getUser(): User{
    let user: User
    user =   JSON.parse(localStorage.getItem(this.storageUser));
    return user;
  }
  getToken(): string {
    return localStorage.getItem(this.storageKey);
  }

  hasToken(): boolean {
    return !!this.getToken();
  }

  clearToken() {
    localStorage.removeItem(this.storageKey);
  }
}
